import React from 'react';
import styled, { css } from 'styled-components';

import TEST_ID from './index.testid';
import Divider from '~/components/atom/Divider';
import TextButton from '~/components/atom/TextButton';
import { emptyFilterGroupV2 } from '../..';
import { ContactFilters__Input } from '~/graphql/types';
import { Heading4, Variant } from '~/components/atom/Typography';
import {
  ButtonsContainer,
  FiltersContainer,
  GroupContainer,
} from '../../commonStyles';
import JustificationContainer from '~/components/atom/JustificationContainer';

export type Props = {
  filters: ContactFilters__Input;
  onChange: (newFilters: ContactFilters__Input) => void;
  loading?: boolean;
};

const text = {
  filtersTitle: 'Filters',
  addGroup: 'Groep toevoegen',
  deleteFilters: 'Alle filters wissen',
  invalidFilter: 'Er is iets misgegaan. Probeer het nog eens.',
};

const BrokenFilterBar: React.FCC<
  Omit<Props, 'filterOptions' | 'onAddFilterGroup'> & {
    boundaryProps: {
      error: Error;
      componentStack: string | null;
      eventId: string | null;
      resetError(): void;
    };
  }
> = ({ filters, onChange, boundaryProps }) => (
  <JustificationContainer
    dataTestId={TEST_ID.CONTAINER}
    direction="column"
    width="100%"
    backgroundColor={{ group: 'white' }}
    padding={['s', 'base', null, 'base']}
    border={{
      radius: 'base',
    }}
  >
    <JustificationContainer width="100%" align="center">
      <Heading4 margin={[null]} variant={Variant.primary}>
        {text.filtersTitle}
      </Heading4>
      <ButtonsContainer>
        <TextButton disabled label={text.addGroup} icon="plus" />

        <TextButton
          label={text.deleteFilters}
          icon="delete"
          onClick={e => {
            e.currentTarget.blur();

            onChange({ ...filters, nodes: [emptyFilterGroupV2()] });
            boundaryProps.resetError();
          }}
        />
      </ButtonsContainer>
    </JustificationContainer>
    <Divider margin={['xxxs', null]} />
    <div style={{ position: 'relative' }}>
      <FiltersContainer>
        <GroupContainer>
          <ErrorContainer>
            <span>{text.invalidFilter}</span>
          </ErrorContainer>
        </GroupContainer>
      </FiltersContainer>
    </div>
  </JustificationContainer>
);

const ErrorContainer = styled.div<{}>(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    height: 50px;
    padding-left: ${theme.space('xxs')};
    color: ${theme.color('danger')};
    position: relative;

    background-color: ${theme.color('white')};
    border-radius: ${theme.getTokens().border.radius.base};

    max-width: ${1200}px;
    width: 100%;
    margin: 0 auto;
  `,
);

export default BrokenFilterBar;
